import { gql } from "apollo-boost"

export const AllAnuncios = gql`
query AllAnuncios($userId: ID){
  allAnuncios(filter:{
    userId: $userId,
    # active: true
  }){
    id
    description
    skill {
      id
      name
    }
    active
    price
    files
    user{
      id
      name
      photo
      ranks {
          media
          typeTo
      }
      address {
          city
          state
      }
    }
  }
}
`;

export const AllAnunciosChip = gql`
query AllAnuncios($userId: ID){
  allAnuncios(filter:{
    userId: $userId,
    active: true
  }){
    id
    description
    skill {
      name
    }
    active
  }
}
`;

// export const Destaques = gql`
// {
//   allUsers(filter: {
//     type: PROFISSIONAL
//     status: true
//     ranks_some: {
//       typeTo: PROFISSIONAL
//     }
//     anuncios_some: {
//       active: true
//     }
//   }){
//     ranks{
//       media
//       typeTo
//     }
//     id
//     name
//     avatar
//     photo
//     address {
//       city
//       state
//     }
//     anuncios {
//       id
//       description
//       price
//       active
//       files
//       skill {
//         name
//       }
//     }
//   }
// }
// `

export const Destaques = gql`
{
  allUsers(filter: {
    type: PROFISSIONAL
    status: true
    ranks: {
      typeTo: PROFISSIONAL
    }
    anuncios: {
      active: true
    }
  }){
    ranks{
      media
      typeTo
    }
    id
    name
    photo
    address {
      city
      state
    }
    anuncios {
      id
      description
      price
      active
      files
      skill {
        name
      }
    }
  }
}
`

export const AnunciosSkill = gql`
query AnunciosSkill($skill: String){
      allAnuncios(
        filter:{
        skill: {
          name: $skill
        }
        active: true
        user: {
          status: true
        }
      }
      ){
        id
        description
        skill {
          id
          name
        }
        active
        price
        files
        user{
          id
          name
          avatar
          photo
          ranks {
              media
              typeTo
          }
          address {
              city
              state
          }
          anuncios {
            active
            skills {
              name
            }
          }
        }
      }
    }
`

export const AnunciosSkillID = gql`
query AnunciosSkillID($id: ID){
      allAnuncios(
        filter:{
        skillId: $id
        active: true
        user: {
          status: true
        }
      }
      ){
        id
        description
        skill {
          id
          name
        }
        active
        price
        files
        user{
          id
          name
          photo
          ranks {
              media
              typeTo
          }
          address {
              city
              state
          }
          anuncios {
            active
            skill {
              name
            }
          }
        }
      }
    }
`

export const SkillName = gql`
query SkillName($id: ID!){
  skill( id: $id ){
name
}
}
`


export const CreateAnuncio = gql`
mutation CreateAnuncio(
    $description: String,
    $skill: ID!,
    $price: String,
     ){
       createAnuncio (
    description: $description,
    skillId: $skill,
    price: $price
  ){
  id
    user{
      id
      name
      type
    }
    description
    skill{
      name
    }
    active
    price
    file
}
}
`

export const AllAnuncioUser = gql`
query ($id: ID){
  allAnuncio(
    filter:{
    userId: $id
  }){
    id
    description
    skill {
      id
      name
    }
    active
    price
    files
    user{
      id
      name
    }
  }
}
`

export const UpdateAnuncio = gql`
mutation UpdateAnuncio(
  $id: ID!,
    $description: String,
    $price: String,
    $active: Boolean,
    $files: [String!]
     ){
       updateAnuncio (
      id: $id,
      description: $description,
      price: $price,
      active: $active,
      filesIds: $files
  ){
  id
    user{
      id
      name
    }
    description
    skill{
      id
      name
    }
    active
    price
    files
}
}
`

export const StatusAnuncio = gql`
mutation UpdateAnuncio($id: ID!, $active: Boolean){
  updateAnuncio (
      id: $id,
      active: $active,
  ){
    id
    user{
      id
      name
    }
    description
    skill{
      id
      name
    }
    active
    price
  }
}
`


export const AllFiles = gql`
query ($id: ID){
  anuncio( id: $id ){
    id
    description
    skill {
      id
      name
    }
    active
    price
    files
  }
}
`